import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { NewGameModal } from '@/components/games/NewGameModal';

export const Route = createFileRoute('/_admin/jogos/new')({
  component: NewGamePage,
});

function NewGamePage() {
  const navigate = useNavigate();

  return (
    <NewGameModal
      open={true}
      onOpenChange={(open) => {
        if (!open) navigate({ to: '/jogos' });
      }}
      onSuccess={() => navigate({ to: '/jogos' })}
    />
  );
}
